// Updated to use ReceiptPrinterEncoder from @point-of-sale/receipt-printer-encoder
import ReceiptPrinterEncoderWrapper from "./receiptPrinterEncoder.js";

// Create a singleton instance with the same configuration as before
const receiptPrinter = ReceiptPrinterEncoderWrapper;

export default receiptPrinter;

// EXAMPLE BILL DATA

// const billData = {
//   billNo: "B12345",
//   hotelData: {
//     name: "My Restaurant",
//     address: "123 Food St",
//     contact: "1234567890",
//   },
//   GST: {
//     gstNumber: "adasdads",
//     fassi_no: "1234567890",
//   },
//   formattedDateTime: "2025-07-01 10:00 AM",
//   roomData: { table: "T1", room: "Parcel" },
//   validItems: [
//     {
//       name: "Paneer Tikka asdasd adasda ddasdasdasd dadasd asd adasd asdasd",
//       quantity: 2,
//       price: 120,
//       isVariant: true,
//       variantName: "adadasdadas dasdasdasdasdasdasdasdadasdasdasdasd",
//     },
//     {
//       name: "Burgeradasdasdasdasdasda",
//       quantity: 1,
//       price: 80,
//       isVariant: false,
//     },
//   ],
//   billTxnLogs: {
//     subTotal: 320,
//     discountFlat: 20,
//     discountPercent: 33,
//     gst: true,
//     cgstPercent: 2.5,
//     sgstPercent: 2.5,
//     cgst: 7.5,
//     sgst: 7.5,
//     tips: 10,
//     total: 325,
//     gstExcluded: false,
//   },
//   customer: {
//     name: "John Doe",
//     phone: "1234567890",
//     address: "1234 Elm Street, Springfield, IL 62704, United States",
//   },
//   qrData: "https://dashboard.qrapid.io/",
// };

// // Example KOT data
// const kotData = {
//   type: "Parcel KOT",
//   formattedDateTime: "2024-03-20 15:30",
//   billNo: "KOT123",
//   roomData: {
//     table: "T1",
//     room: "Parcel",
//   },
//   customer: {
//     name: "John Doe",
//     phone: "1234567890",
//     address: "1234 Elm Street, Springfield",
//   },
//   cartItems: [
//     {
//       name: "Chicken Biryani",
//       quantity: 2,
//       isVariant: true,
//       variantName: "Full Portion",
//       comment: "Extra spicy, with raita",
//       canceled: false,
//     },
//     {
//       name: "Butter Naan",
//       quantity: 4,
//       isVariant: false,
//       comment: "Fresh and hot",
//       canceled: false,
//     },
//   ],
//   cancelItems: [
//     {
//       name: "Paneer Tikka",
//       quantity: 1,
//       isVariant: true,
//       variantName: "Half Portion",
//     },
//   ],
//   comment: "Urgent order, VIP customer",
// };

// // Create printer instance
// const printer = new ReceiptPrinterEncoderWrapper(48, 1);

// // Print KOT
// console.log("Printing KOT:");
// const kotReceipt = printer.printKOT(kotData);
// console.log(kotReceipt);

// // Print Bill (existing example)
// console.log("\nPrinting Bill:");
// const billReceipt = printer.printBill(billData);
// console.log(billReceipt);
